var map = {
	"./aparthotelclub/ic_instagram_link_circle.png": 32498,
	"./beachful/ic_instagram_link_circle.png": 80364,
	"./castlepedia/ic_instagram_link_circle.png": 95885,
	"./cocktayl/ic_instagram_link_circle.png": 36279,
	"./ic_instagram_link_circle.png": 20424,
	"./luxresortclub/ic_instagram_link_circle.png": 92706,
	"./parkful/ic_instagram_link_circle.png": 27973,
	"./prefabworld/ic_instagram_link_circle.png": 98504,
	"./rooftopclub/ic_instagram_link_circle.png": 36464,
	"./spaclub/ic_instagram_link_circle.png": 5771,
	"./worldcasino/ic_instagram_link_circle.png": 7431,
	"./zoopedia/ic_instagram_link_circle.png": 99344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82344;